/**
 * check the module permission has given to the logged in admin user or not
 * @param {object} userOrPermissions login user data or permission data
 * @param {string} module module name
 * @param {string} action action name
 * @returns {boolean} return the boolean
 */
export const checkPermission = (userOrPermissions, module, action) => {
	// Extract role
	let role = "";
	if (userOrPermissions && typeof userOrPermissions === "object" && userOrPermissions.role) {
		role = userOrPermissions.role;
	}

	// Fallback to localStorage if role not found in the argument
	if (!role) {
		try {
			const serializedState = localStorage.getItem("state");
			if (serializedState) {
				const parsedState = JSON.parse(serializedState);
				if (parsedState && parsedState.auth && parsedState.auth.loginUserData) {
					role = parsedState.auth.loginUserData.role;
				}
			}
		} catch (e) {
			// fallback
		}
	}

	// If role is superAdmin or corporate, they always have permission
	if (role && (role.toLowerCase() === "superadmin" || role.toLowerCase() === "super_admin" || role.toLowerCase() === "corporate")) {
		return true;
	}

	if (!userOrPermissions) return false;
	if (module && module.toLowerCase() === "dashboard") return true;

	// Extract permissions
	let permissions = userOrPermissions;
	if (userOrPermissions && typeof userOrPermissions === "object" && userOrPermissions.permissions) {
		permissions = userOrPermissions.permissions;
	}

	if (!permissions || !module || !action) return false;

	const normModule = module.toLowerCase();
	const normAction = action.toLowerCase();

	// Support aliases for actions (e.g. add/create)
	const actionAliases = [normAction];
	if (normAction === "create") actionAliases.push("add");
	if (normAction === "add") actionAliases.push("create");

	// Support aliases for modules (plural/singular and sub_category variants)
	const moduleAliases = [normModule];
	if (normModule.endsWith("s")) {
		moduleAliases.push(normModule.slice(0, -1));
	} else {
		moduleAliases.push(normModule + "s");
	}
	if (normModule === "sub_category" || normModule === "subcategory" || normModule === "sub_categories" || normModule === "subcategories") {
		moduleAliases.push("sub_category");
		moduleAliases.push("subcategory");
		moduleAliases.push("sub_categories");
		moduleAliases.push("subcategories");
	}

	// Find the module
	const moduleKey = Object.keys(permissions).find(
		key => moduleAliases.includes(key.toLowerCase())
	);

	if (moduleKey && permissions[moduleKey]) {
		// Find if any of the action aliases are true
		const match = Object.keys(permissions[moduleKey]).find(key => {
			const k = key.toLowerCase();
			return actionAliases.includes(k) && permissions[moduleKey][key] === true;
		});
		if (match) return true;
	}

	return false;
}